import { render, staticRenderFns } from "./PageRoutes.vue?vue&type=template&id=2df6042c&"
import script from "./PageRoutes.vue?vue&type=script&lang=js&"
export * from "./PageRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2df6042c')) {
      api.createRecord('2df6042c', component.options)
    } else {
      api.reload('2df6042c', component.options)
    }
    module.hot.accept("./PageRoutes.vue?vue&type=template&id=2df6042c&", function () {
      api.rerender('2df6042c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routes/PageRoutes.vue"
export default component.exports